import Image from 'app/Components/Shared/Image/image';
import React, {useEffect, useRef, useState, CSSProperties} from 'react';
import classNames from 'classnames';
import HiddenStopAndStartButton from 'app/utilities/HiddenStopAndStartButton';
import {ImageProps} from 'app/utilities/ImageProps';

export type TVSliderProps = {
  subtitle: string;
  images: ImageProps[];
  size: number;
  gap?: number;
  columns?: number;
  duration: number;
  isChannels?: boolean;
  iconImage: ImageProps;
};

const CLONES = 4;

const TVSlider = ({iconImage, subtitle, images, size, duration, gap = 0, columns = 1, isChannels}: TVSliderProps) => {
  const parrentRef = useRef<HTMLDivElement>();
  const ref = useRef<HTMLDivElement>();
  const [swiperIsStop, setSwiperIsStop] = useState<Boolean>(false);
  const [swiperAutoPlay, setSwiperAutoPlay] = useState('Stop');
  const [durationSlider, setDurationSlider] = useState(duration);

  const height = !isChannels ? size * 1.5 : size;
  useEffect(() => {
    const total = parrentRef.current.clientWidth;
    const container = ref.current;
    container.innerHTML = '';
    if (images.length == 0) return;
    // calculate how much clones do we need
    const x = Math.ceil(((total * CLONES + gap) / (size + gap)) * columns);
    for (let i = 0; i < x || i < images.length || i % columns != 0; i++) {
      const srcAndAlt = images[i % images.length];
      const img = document.createElement('img');
      img.src = srcAndAlt.src;
      img.alt = srcAndAlt.alt;
      img.style.width = `${size}px`;
      img.style.height = `${height}px`;

      container.appendChild(img);
    }
  }, [images]);

  useEffect(() => {
    if (swiperIsStop) {
      setDurationSlider(0);
      setSwiperAutoPlay('Start');
    } else {
      setDurationSlider(duration);
      setSwiperAutoPlay('Stop');
    }
  }, [swiperIsStop]);

  const style = {
    '--custom-gap': `${gap}px`,
    height: `${(gap + height) * columns - gap}px`,
    animationDuration: `${durationSlider * CLONES}s`,
  } as CSSProperties;

  return (
    <>
      <HiddenStopAndStartButton className='' onClick={() => setSwiperIsStop((prevState) => !prevState)} swiperAutoPlay={swiperAutoPlay} />

      <div className='TVSlider' ref={parrentRef}>
        <div className='TVSlider__label'>
          <Image {...iconImage} />
          <div className='TVSlider__subtitle'>{subtitle}</div>
        </div>
        <div className={classNames('TVSlider__images', {channels: isChannels})} ref={ref} style={style} />
      </div>
    </>
  );
};

export default TVSlider;
